import axios from 'axios';
import { getToken } from './security';

const http = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_URL,
  // Sin timeout el cliente esperaba indefinidamente y quien cortaba era el gateway, devolviendo un
  // 504 con cuerpo HTML que el manejo de errores no sabia leer (AB#10815). 60 s deja lugar de sobra
  // a los pasos que consultan servicios externos y sigue estando por debajo de lo que tarda alguien
  // en darse por vencido y recargar.
  timeout: 60000,
});

const headersApim = {
  'Ocp-Apim-Subscription-Key': process.env.NEXT_PUBLIC_API_KEY,
};

http.interceptors.request.use((config) => {
  // AB#11070 / DEV-FE-04: reemplazar config.headers entero (en vez de mergear) descartaba
  // headers puestos por el llamador (ej. `includes: '2'` de getValidateJuridico/getValidateRl),
  // asi que el backend nunca los recibia y devolvia el payload sin Domicilio.
  config.headers = {
    ...config.headers,
    ...headersApim,
    token: getToken(),
  };
  return config;
});

http.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response) {
      await fetch('/api/logs', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          error: error.response?.data,
          // url: error.config.url,
          method: error.config.method,
        }),
      });

      return Promise.reject(error.response);
    }

    // Sin respuesta: timeout del cliente, corte de red o CORS (AB#10815, DEV-FE-05).
    //
    // Antes esto hacia `return false`, o sea RESOLVIA la promesa. handleResponse leia `false.error`
    // como undefined, lo tomaba por exito y devolvia true: una falla de red se leia como un paso
    // completado. Con el timeout que ahora tiene el cliente ese camino pasa a ser frecuente, asi
    // que devolver algo que el llamador pueda distinguir dejo de ser opcional.
    return Promise.reject({
      status: error.code === 'ECONNABORTED' ? 504 : 0,
      data: null,
      error: true,
      codigo: 'SERVICIO_NO_DISPONIBLE',
    });
  }
);

export default http;
